import React from 'react';
import { Link } from 'react-router-dom';
import logoSm from '../assets/images/logo-in-white.png';
import logoDark from '../assets/images/logo-in-white.png';
import logoLight from '../assets/images/logo-in-white.png';
import { changeSidebarVisibility } from '../slices/thunks';
import { useSelector, useDispatch } from 'react-redux';
import { createSelector } from 'reselect';
import HeaderProfileDropdown from 'Components/Common/HeaderProfileDropdown';
import { AppDispatch, RootState } from 'store';
import Avatar from 'react-avatar';

const Header = ({
    headerClass,
}: {
    headerClass?: string;
    layoutModeType?: unknown;
    onChangeLayoutMode?: (value: unknown) => void;
}) => {
    const dispatch = useDispatch<AppDispatch>();

    const campaignData = useSelector((state: RootState) => state.ui.header?.campaignData);
    const detailPage = useSelector((state: RootState) => state.ui.header?.detailPage);
    const campaignsLocation = useSelector((state: RootState) => state.ui.campaignsLocation);
    const lastActiveCampaignTab = useSelector((state: RootState) => state.ui.lastActiveCampaignTab);

    const selectDashboardData = createSelector(
        (state: RootState) => state.Layout,
        (sidebarVisibilitytype) => sidebarVisibilitytype.sidebarVisibilitytype
    );
    const sidebarVisibilitytype = useSelector(selectDashboardData);

    const toogleMenuBtn = () => {
        const windowSize = document.documentElement.clientWidth;
        const humberIcon = document.querySelector('.hamburger-icon') as HTMLElement;
        dispatch(changeSidebarVisibility('show'));

        if (windowSize > 767) {
            humberIcon.classList.toggle('open');
        }

        if (document.documentElement.getAttribute('data-layout') === 'horizontal') {
            document.body.classList.contains('menu')
                ? document.body.classList.remove('menu')
                : document.body.classList.add('menu');
        }

        if (
            sidebarVisibilitytype === 'show' &&
            (document.documentElement.getAttribute('data-layout') === 'vertical' ||
                document.documentElement.getAttribute('data-layout') === 'semibox')
        ) {
            if (windowSize < 1025 && windowSize > 767) {
                document.body.classList.remove('vertical-sidebar-enable');
                document.documentElement.getAttribute('data-sidebar-size') === 'sm'
                    ? document.documentElement.setAttribute('data-sidebar-size', '')
                    : document.documentElement.setAttribute('data-sidebar-size', 'sm');
            } else if (windowSize > 1025) {
                document.body.classList.remove('vertical-sidebar-enable');
                document.documentElement.getAttribute('data-sidebar-size') === 'lg'
                    ? document.documentElement.setAttribute('data-sidebar-size', 'sm')
                    : document.documentElement.setAttribute('data-sidebar-size', 'lg');
            } else if (windowSize <= 767) {
                document.body.classList.add('vertical-sidebar-enable');
                document.documentElement.setAttribute('data-sidebar-size', 'lg');
            }
        }

        if (document.documentElement.getAttribute('data-layout') === 'twocolumn') {
            document.body.classList.contains('twocolumn-panel')
                ? document.body.classList.remove('twocolumn-panel')
                : document.body.classList.add('twocolumn-panel');
        }
    };

    return (
        <div className={`new-header d-flex justify-content-between align-items-center ${headerClass ?? ''}`}>
            <div className="header-left d-flex justify-content-start align-items-center gap-3">
                <button
                    onClick={toogleMenuBtn}
                    type="button"
                    className="btn btn-sm px-3 fs-16 header-item vertical-menu-btn topnav-hamburger"
                    id="topnav-hamburger-icon"
                >
                    <span className="hamburger-icon">
                        <span></span>
                        <span></span>
                        <span></span>
                    </span>
                </button>
                {campaignData ? (
                    <>
                        <Link to={campaignsLocation} className="nav-btn cursor-pointer">
                            <i className="mdi mdi-arrow-left" />
                        </Link>
                        <div className="campaign-desc d-flex justify-content-start align-items-center gap-3 d-none d-md-flex">
                            {campaignData.brand?.img_url ? (
                                <div
                                    className="header-brand-logo bg-image bgc-white"
                                    style={{ backgroundImage: `url(${campaignData.brand.img_url})` }}
                                />
                            ) : (
                                <Avatar
                                    name={campaignData.campaign?.name}
                                    size="40"
                                    maxInitials={1}
                                    round="4px"
                                />
                            )}
                            <div className="d-flex flex-column justify-content-between">
                                <span className="campaign-name">{campaignData.campaign?.name}</span>
                                {campaignData.campaign?.mode !== 'offline' && (
                                    <div className="campaign-actions d-flex gap-2">
                                        {detailPage ? (
                                            <Link
                                                to={`/campaign/${campaignData.campaign.uuid}/${lastActiveCampaignTab}`}
                                                className="text-primary d-flex align-items-center gap-1"
                                            >
                                                Hide Details
                                                <i className="fs-15px ms-1 bg-primary-light bx bx-chevron-up" />
                                            </Link>
                                        ) : (
                                            <Link
                                                to={`/campaign/${campaignData.campaign.uuid}`}
                                                className="text-primary d-flex align-items-center gap-1"
                                            >
                                                Show Details
                                                <i className="fs-15px ms-1 bg-primary-light bx bx-chevron-down" />
                                            </Link>
                                        )}
                                    </div>
                                )}
                            </div>
                        </div>
                    </>
                ) : (
                    <div className="navbar-brand-box horizontal-logo">
                        <Link to="/" className="logo logo-dark">
                            <span className="logo-sm">
                                <img src={logoSm} alt="" height="22" />
                            </span>
                            <span className="logo-lg">
                                <img src={logoDark} alt="" height="17" />
                            </span>
                        </Link>
                        <Link to="/" className="logo logo-light">
                            <span className="logo-sm">
                                <img src={logoSm} alt="" height="22" />
                            </span>
                            <span className="logo-lg">
                                <img src={logoLight} alt="" height="17" />
                            </span>
                        </Link>
                    </div>
                )}
            </div>
            <div className="header-right d-flex justify-content-end align-items-center">
                <HeaderProfileDropdown />
            </div>
        </div>
    );
};

export default Header;
